import styled from '@emotion/styled';

// Local Typings
interface Props {
  delayInSeconds?: number;
  intervalInSeconds?: number;
}

// Component Definition
const Pulse = styled.span<Props>(({
  delayInSeconds = 0,
  intervalInSeconds = 2,
}) => ({
  /* eslint-disable @typescript-eslint/naming-convention */
  '& > *': {
    animation: `bounce ${intervalInSeconds}s ease-in-out infinite`,
    animationDelay: `${delayInSeconds}s`,

    /* eslint-disable sort-keys */
    '@keyframes bounce': {
      '50%': {
        transform: 'scale(1.2)',
      },
      'from, 0%, 35%, 65%, 100%': {
        transform: 'scale(1)',
      },
    },
    /* eslint-enable sort-keys */
  },
  /* eslint-enable @typescript-eslint/naming-convention */
}));

export default Pulse;
